export { default } from "./CardLimitsControl";



// WEBPACK FOOTER //
// ./src/components/emission/cards/controls/CardLimitsControl/index.js